import React from "react"
import Layout from "../components/Layout"

const copy = {
  en: {
    image_alt: "Step flow diagram from thinking to settle down",
    steps: [
      "Thinking about or exploring the idea of moving to Canada",
      "Start Stream A / B pathway, or traditional options like investment, family reunion, professional program",
      "Submit your immigration application",
      "Receive approval from the Canadian Government",
      "Prepare for your move from Hong Kong to Canada",
      "Book your flight tickets",
      "Choose the city or community where you want to settle",
      "Rent a house or apartment",
      "Look for a job in Canada",
      "Apply for a Canadian driver’s license",
      "Learn about commuting and transportation in your city",
      "Arrange insurance such as OHIP, home, car, etc.",
      "Find a local church near where you live",
    ],
    help_title: "Need More Help or the Latest Updates",
    help_body:
      "Do you have questions about the process of moving to Canada? Friendly volunteers from different churches are here to help and answer your questions. Join our newcomer community to learn, connect, and share your journey together.",
  },
  cn: {
    image_alt: "由考慮到安頓的流程圖",
    steps: [
      "正在考慮或探索移居加拿大",
      "開始「Stream A 或 B」流程，或傳統途徑如投資、家庭團聚、專業人士等",
      "遞交移民申請",
      "獲得加拿大政府審批",
      "準備從香港出發及來加所需事項",
      "購買機票",
      "選擇合適的定居城市或社區",
      "租住房屋或公寓",
      "尋找加拿大工作",
      "申請加拿大駕駛執照",
      "了解所在城市的日常交通與通勤方式",
      "保險需求（例如 OHIP、住宅、汽車等）",
      "在居住地附近尋找教會或社群",
    ],
    help_title: "需要更多幫助與最新資訊?",
    help_body:
      "對移居加拿大的流程有疑問嗎？我們一班來自不同教會的義工樂意幫助你，並解答你的問題。歡迎加入我們的新移民社群，一起學習、交流與分享。",
  },
}

const Step = ({ lang = "en" }) => {
  const t = key => copy[lang][key]

  return (
    <Layout lang={lang}>
      <section className="index__section">
        {/* Step Flow Image Banner */}
        <div className="step__header">
          <div className="header__media steps" />
        </div>

        {/* Step-by-step Bullet List */}
        <div className="index__item">
          <div className="index__media o__arrows" />
          <ul className="step__list">
            {t("steps").map((line, idx) => (
              <li key={idx}>{line}</li>
            ))}
          </ul>
        </div>

        <div className="index__divider" />

        <div className="index__item">
          <div className="index__media o__puzzle" />
          <div className="index__item-content o__pink">
            <h2>{t("help_title")}</h2>
            <p>{t("help_body")}</p>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Step
